import { send } from '../../../../../../../../src/network';
import { type Cart } from '../../../../../../../../src/types/Cart';

interface RequestParams {
  bundleId: number;
  pairingId?: number;
  productId?: number;
}

export async function patchBundleRequest(params: RequestParams) {
  const { bundleId, pairingId, productId } = params;
  const body = productId
    ? { product_id: productId }
    : { pairing_id: pairingId };
  return send<Cart>({
    path: `/api/v2/customers/self/cart/bundles/${bundleId}/`,
    method: 'PATCH',
    body,
  });
}
